// ═══════════════════════════════════════════════════════════════════════════════
// PWA — offline + sync status strip (fixed top)
// ═══════════════════════════════════════════════════════════════════════════════

import { useTranslationSafe } from '../contexts/LanguageContext';
import { useOfflineSync } from '../contexts/OfflineSyncContext';

export const PwaOfflineBanner = () => {
  const t = useTranslationSafe();
  const { isOnline, syncState, syncMessage, pendingCount } = useOfflineSync();

  if (isOnline && syncState === 'idle' && pendingCount === 0) {
    return null;
  }

  if (!isOnline) {
    return (
      <div
        className="fixed left-0 right-0 top-0 z-[100] border-b border-amber-200 bg-amber-100 px-4 py-2 text-center text-sm text-amber-950"
        role="status"
        aria-live="polite"
      >
        {t('pwa.offlineBanner')}
      </div>
    );
  }

  if (syncState === 'syncing') {
    return (
      <div
        className="fixed left-0 right-0 top-0 z-[100] border-b border-blue-200 bg-blue-50 px-4 py-2 text-center text-sm text-blue-900"
        role="status"
        aria-live="polite"
      >
        {t('pwa.syncing')}
      </div>
    );
  }

  if (syncState === 'error') {
    return (
      <div
        className="fixed left-0 right-0 top-0 z-[100] border-b border-red-200 bg-red-50 px-4 py-2 text-center text-sm text-red-900"
        role="alert"
        aria-live="assertive"
      >
        {syncMessage ?? t('pwa.syncFailed')}
      </div>
    );
  }

  if (syncState === 'done') {
    return (
      <div
        className="fixed left-0 right-0 top-0 z-[100] border-b border-green-200 bg-green-50 px-4 py-2 text-center text-sm text-green-900"
        role="status"
        aria-live="polite"
      >
        {t('pwa.syncComplete')}
      </div>
    );
  }

  if (pendingCount > 0) {
    return (
      <div
        className="fixed left-0 right-0 top-0 z-[100] border-b border-amber-200 bg-amber-50 px-4 py-2 text-center text-sm text-amber-950"
        role="status"
        aria-live="polite"
      >
        {t('pwa.pendingSync')}
      </div>
    );
  }

  return null;
};
